import React from "react";
import "./App.css";
import { Toaster } from "./components/ui/sonner";
import LandingPage from "./pages/LandingPage";

function App() {
  return (
    <div className="App">
      <LandingPage />
      <Toaster />
    </div>
  );
}

export default App;
